// Our Work gallery. The live S3 gallery overrides these when available; until a
// client seeds their own photos, we fall back to the MaestroShield lifestyle
// assets so the section always renders with real installation imagery.
import { ASSETS } from './assets-data';

const LIFE_IMAGES = [
    ASSETS.SUNSET_OCEAN_VIEW_COVERED_PATIO_SECTIONAL_SOFA,
    ASSETS.OUTDOOR_PERGOLA_ENCLOSURE_WITH_ROLLER_BLINDS_DARK_FRAME,
    ASSETS.POOL_PATIO_MOTORIZED_SCREEN_SHADES_EXTERIOR,
    ASSETS.MODERN_WHITE_SCREENED_PATIO_ENCLOSURE_EXTERIOR,
    ASSETS.FLORIDA_WATERFRONT_MODERN_PERGOLA_WITH_LOUVERED_ROOF,
    ASSETS.ROOFTOP_BAR_PATIO_WOOD_CEILING_CEILING_FANS_BALCONY_VIEW,
    ASSETS.SIROCCO_MEDITERRANEAN_RESTAURANT_OUTDOOR_PATIO_SCREENS,
    ASSETS.POOL_PATIO_MOTORIZED_SCREEN_SHADES_EXTERIOR_2,
    ASSETS.AIRSTREAM_CARPORT_STONE_COLUMN_MOTORIZED_SCREENS,
    ASSETS.RESTAURANT_PATIO_GREEN_RAILING_OUTDOOR_DINING_STREET_VIEW,
].filter(Boolean);

const ourWorkData = {
    en: {
        seo: {
            title: 'Our Work | {business}',
            description: 'Browse recent retractable screen installations, motorized patio, pool, and pergola enclosures built for outdoor living.',
            keywords: 'retractable screens, motorized screens, patio enclosure, {business}'
        },
        ui: {
            eyebrow: 'Our Work',
            titleMain: 'Recent Projects',
            subtitle: 'A look at retractable screen installations across patios, pools, and outdoor living spaces.',
            noImagesText: 'Gallery coming soon.',
            membersStat: { value: '500+', label: 'PROJECTS COMPLETED' },
            eventsStat: { value: '15+', label: 'YEARS OF EXPERIENCE' },
            seeMoreText: 'See More Projects',
            seeMoreLink: '/our-work',
            images: LIFE_IMAGES,
        }
    },
    he: {
        seo: {
            title: 'העבודות שלנו | {business}',
            description: 'התקנות רשתות נגללות אחרונות, פתרונות ממונעים למרפסות, בריכות ופרגולות למגורים בחוץ.',
            keywords: 'רשתות נגללות, רשתות ממונעות, סגירת מרפסת, {business}'
        },
        ui: {
            eyebrow: 'העבודות שלנו',
            titleMain: 'פרויקטים אחרונים',
            subtitle: 'מבט על התקנות רשתות נגללות במרפסות, בריכות ומרחבי מחיה בחוץ.',
            noImagesText: 'הגלריה בקרוב.',
            membersStat: { value: '500+', label: 'פרויקטים שהושלמו' },
            eventsStat: { value: '15+', label: 'שנות ניסיון' },
            seeMoreText: 'לעוד פרויקטים',
            seeMoreLink: '/our-work',
            images: LIFE_IMAGES,
        }
    }
};

export function getOurWorkData(language) {
    return ourWorkData[language === 'he' ? 'he' : 'en'];
}

export default ourWorkData;
